'use client';

import { useEffect, useState } from 'react';
import AffiliateLink from '@/components/common/AffiliateLink';

/**
 * Липкий нижний CTA для мобильных (GF-стиль .pv-sticky из референса
 * «Провайдер.html»: имя + цена слева, квадратная pine-кнопка справа).
 *
 * Зачем: на длинной странице провайдера денежная кнопка есть только в самом
 * верху (hero) и в самом низу. Пока пользователь читает преимущества/тарифы,
 * кнопки на экране нет. Этот бар держит конверсию в зоне большого пальца всё время.
 *
 * Показывается только на мобильных (см. .pv-sticky в gallery-field.css)
 * и только если есть валидный href. Появляется, когда кнопка hero ушла с экрана,
 * и прячется у нижнего CTA — иначе две одинаковые кнопки стоят рядом.
 *
 * @param {string} name       имя бренда в левой колонке
 * @param {string} priceLabel подпись под именем («от 9 $» / «Туры · Грузия»)
 * @param {string} price      числовая цена для трекинга клика (не для показа)
 */
export default function StickyMobileCta({
    href,
    provider,
    vertical,
    country,
    price,
    name,
    priceLabel,
    label,
}) {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const hero = document.querySelector('.pv-cta');
        const bottom = document.querySelector('.gf-cta');
        if (!hero || typeof IntersectionObserver === 'undefined') return undefined;
        const state = { heroVisible: true, bottomVisible: false };
        const observer = new IntersectionObserver((entries) => {
            for (const entry of entries) {
                if (entry.target === hero) state.heroVisible = entry.isIntersecting;
                if (entry.target === bottom) state.bottomVisible = entry.isIntersecting;
            }
            setVisible(!state.heroVisible && !state.bottomVisible);
        });
        observer.observe(hero);
        if (bottom) observer.observe(bottom);
        return () => observer.disconnect();
    }, []);

    if (!href || href === '#') return null;

    return (
        <div className={`pv-sticky${visible ? ' is-visible' : ''}`} aria-hidden={!visible}>
            <div className="meta">
                {name && <span className="nm">{name}</span>}
                {priceLabel && <span className="pr">{priceLabel}</span>}
            </div>
            <AffiliateLink
                href={href}
                provider={provider}
                vertical={vertical}
                country={country}
                price={price}
                position="sticky"
            >
                {label} →
            </AffiliateLink>
        </div>
    );
}
